// Shared pen-capture display helpers, used by both the refill CaptureCard and
// the grow ReadingCaptureCard so the live "big number" strip and its number
// formatting live in one place.

/** One large, glanceable live pen metric (label + value). */
export function LiveMetric({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col">
      <dt className="text-[10px] uppercase tracking-wide text-muted-foreground">
        {label}
      </dt>
      <dd className="text-2xl font-semibold tabular-nums leading-none">
        {value}
      </dd>
    </div>
  );
}

/** Format a live value to fixed digits, or "—" when absent/non-finite. */
export function fmt(v: number | undefined | null, digits: number): string {
  return v === undefined || v === null || !Number.isFinite(v)
    ? "—"
    : v.toFixed(digits);
}

/** Format a converted number without trailing-zero noise (8.50 → "8.5"). */
export function trimNum(n: number): string {
  return String(Number(n.toFixed(2)));
}
